<template>
  <div>
    <header class="main-content--header">
      <h4>Activity</h4>
    </header>
    <section class="main-content--body">
      <div class="wrapper-md">
        <div class="main-content--panel">
          <div v-if="activity">
            <table>
              <thead>
              <tr>
                <th>Duration</th>
                <th>Reason</th>
                <th>Date</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in activities">
                <td>{{item.duration | capitalize}}</td>
                <td>{{item.reason | capitalize}}</td>
                <td>{{item.date}}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <div v-else>
            <div class="no-activity">
              <h2>Oops!</h2>
              <h3>Nothing to see here!</h3>
              <h3>Looks like you've never signed in to your team before.</h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import axios from 'axios'
  import moment from 'moment'
  import tz from 'moment-timezone'

  export default {
    name: 'Activity',
    data () {
      return {
        activities: {},
        activity: false
      }
    },
    head: {
      title: {
        inner: 'Activity',
        separator: '-',
        complement: 'Worklogs'
      },
    },
    filters: {
      capitalize: function (value) {
        if (!value) return ''
        value = value.toString()
        return value.charAt(0).toUpperCase() + value.slice(1)
      }
    },
    beforeRouteEnter (to, from, next) {
      axios.get('https://api.kuzcoapp.com/api/v1/log?perPage=100')
        .then ( function(response) {
          let _activities = response.data.data.records
          next(vm => {
            if (Object.keys(_activities).length == 0) {
              vm.activity = false
            }
            else {
              vm.activity = true
            }
            let newActivities = {};

            for( let i in _activities) {

              let one = _activities[i]
              let two = _activities[i]
              if (_activities[i].length == 1) {
                let signintime = one[0].created_at;
                let start = moment(signintime);
                let end = moment().format();

                let duration = moment.duration(start.diff(end));
                let _reason = one[0].log_description;
                let _date = signintime;

                let _momentdate = moment(_date).format('MMMM Do YYYY, h:mm:ss a')

                newActivities[i] = {
                  duration: 'Still signed in',
//                  duration: duration,
                  date: _momentdate,
                  reason: _reason
                }
                vm.activities = newActivities;
              }
              else if (_activities[i].length == 2) {
                let signintime = one[0].created_at;
                let signouttime = two[1].created_at;

                let start = moment(signintime);
                let end = moment(signouttime);

                let duration = moment.duration(start.diff(end));

                let reasonone = one[0].log_description;
                let reasontwo = two[1].log_description;
                let _reason = reasontwo ? reasontwo : reasonone ? reasonone : ''

                let _date = signouttime;
                let _momentdate = moment(_date).format('MMMM Do YYYY, h:mm:ss a')

                newActivities[i] = {
                  duration: duration.humanize(),
                  date: _momentdate,
                  reason: _reason
                }
                vm.activities = newActivities;
              }
              else {

              }
            }
          })
        })
        .catch ( function(error) {
          next(false)
          console.log(error);
        });
    },
    watch: {
      $route () {
        let self = this
        axios.get('https://api.kuzcoapp.com/api/v1/log?perPage=100')
          .then ( function(response) {
            let _activities = response.data.data.records
            if (Object.keys(_activities).length == 0) {
              self.activity = false
            }
            else {
              self.activity = true
            }
            let newActivities = {};
            for( let i in _activities) {
              let one = _activities[i]
              let two = _activities[i]
              if (_activities[i].length == 1) {
                let signintime = one[0].created_at;
                let start = moment(signintime);
                let end = moment().format();

                let duration = moment.duration(start.diff(end));
                let _reason = one[0].log_description;
                let _date = signintime;

                let _momentdate = moment(_date).format('MMMM Do YYYY, h:mm:ss a')

                newActivities[i] = {
                  duration: 'Still signed in',
//                  duration: duration,
                  date: _momentdate,
                  reason: _reason
                }
                self.activities = newActivities;
              }
              else if (_activities[i].length == 2) {
                let signintime = one[0].created_at;
                let signouttime = two[1].created_at;

                let start = moment(signintime);
                let end = moment(signouttime);

                let duration = moment.duration(start.diff(end));

                let reasonone = one[0].log_description;
                let reasontwo = two[1].log_description;
                let _reason = reasontwo ? reasontwo : reasonone ? reasonone : ''

                let _date = signouttime;

                newActivities[i] = {
                  duration: duration.humanize(),
                  date: _date,
                  reason: _reason
                }
                self.activities = newActivities;
              }
              else {

              }
            }
          })
          .catch ( function(error) {
            console.log(error);
          });
      }
    }
  }
</script>

<style scoped lang="scss" type="text/scss">
  $themecolor: #4671fb;
  $oldthemecolor: #3e454f;
  $kuzcogreen: #40CF97;
  .status {
    border-radius: 100%;
    width: 8px;
    height: 8px;
    border-width: 4px;
    color: $kuzcogreen;
    border-style: solid;
    display: inline-block;
  }
  table {
    font-size: 14px;
  }
  th {
    padding: 15px;
    border-bottom: 1px solid #D7E2E9;
  }
  tr {
    cursor: pointer;
  }
  td {
    padding: 15px;
    border-top: 1px solid #D7E2E9;
  }
  .no-activity {
    text-align: center;
    padding-top: 28%;
    padding-bottom: 28%;
    h2 {
      font-family: "Proxima Bold";
      font-size: 19px;
    }
    h3 {
      font-size: 16px;
    }
  }
</style>



// WEBPACK FOOTER //
// Activity.vue?0e2c1557